import { Box, Typography } from '@mui/material'
import { COLORS } from '../../constants'
import { CaseStudy } from '../../utils/siteContent'
import Tag from './Tag'

const ROWS: { key: 'problem' | 'work' | 'result', label: string }[] = [
    { key: 'problem', label: 'Problem' },
    { key: 'work', label: 'What I did' },
    { key: 'result', label: 'Result' },
]

/** `compact` drops "What I did" (homepage); `wide` lays the three rows out side by side for a full-width lead story. */
function CaseStudyCard({ study, compact = false, wide = false }: { study: CaseStudy, compact?: boolean, wide?: boolean }) {
    const rows = compact ? ROWS.filter((r) => r.key !== 'work') : ROWS
    return (
        <Box component="article" id={study.id} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, backgroundColor: COLORS.white, border: `1px solid ${COLORS.border}`, scrollMarginTop: 90 }}>
            <Typography variant="overline" component="p" sx={{ color: COLORS.muted }}>{study.category}</Typography>
            <Typography variant="h3" sx={{ mt: 0.5 }}>{study.title}</Typography>
            {study.role && !compact && (
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                    My role: <Box component="span" sx={{ fontWeight: 400, color: 'text.secondary' }}>{study.role}</Box>
                </Typography>
            )}
            <Box component="dl" sx={{ m: 0, mt: 2.5, display: 'grid', gap: wide ? { xs: 2, md: 4 } : 2, gridTemplateColumns: wide ? { xs: '1fr', md: 'repeat(3, 1fr)' } : '1fr' }}>
                {rows.map((r) => (
                    <Box key={r.key}>
                        <Typography component="dt" sx={{ fontWeight: 700, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: r.key === 'result' ? COLORS.accentOnLight : COLORS.black }}>
                            {r.label}
                        </Typography>
                        <Typography component="dd" sx={{ m: 0, mt: 0.5, color: 'text.secondary' }}>{study[r.key]}</Typography>
                    </Box>
                ))}
            </Box>
            <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {study.tags.map((t) => <Tag key={t} text={t} />)}
            </Box>
        </Box>
    )
}

export default CaseStudyCard
